import { Box } from "@mui/material";
import clsx from "clsx";
import { FC } from "react";
import { MobileStepIconProps } from "../lib/type";

export const MobileStepIcon: FC<MobileStepIconProps> = ({ completed, active, percent = 0 }) => {
    const baseColor = completed || active ? 'var(--blue)' : 'var(--light-gray)';
    const gradientColor = completed
    ? 'var(--blue)'
    : active
    ? 'var(--blue-opacity-99)'
    : 'var(--light-gray)';
    const gradientStyle = {
        background:
            percent === 0 && active
                ? `var(--blue-opacity-99)`
                : `linear-gradient(90deg, ${baseColor} ${percent}%, ${gradientColor} ${percent}%)`,
    };

    return <Box className={clsx("rounded-sm w-full min-w-[50px] h-[8px]")} style={gradientStyle} />;
};
